export enum PageNamesEnum {
    CHEF_IT = 'Chef_It',
    CLEAN_IT = 'Clean_It'
}
